import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import routesConfig from 'constants/routesConfig.json';

// components
import ErrorBoundary from 'layout/components/ErrorBoundary';
import TeamPage from 'teamProfiles/pages/TeamPage';
import EmployeeProfileContent from 'teamProfiles/components/EmployeeProfileContent';

// hooks
import { useProfiles } from 'teamProfiles/hooks/teamApi';
import useWindowSize from 'shared/hooks/useWindowResize';
import breakpoints from 'theme/atoms/breakpoints';

// styles
import * as PageLayout from 'layout/styles/PageLayout.style';

export default function ProfilePage(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const { data: profiles } = useProfiles();
  const windowSize = useWindowSize();
  const isDesktopView = windowSize[0] > parseInt(breakpoints.tablet, 10);

  const handleProfileClick = (profileId: string) => {
    if (isDesktopView) {
      history.replace(`${routesConfig.TEAM_PAGE}/${profileId}`);
    } else {
      history.push(`${routesConfig.TEAM_PAGE}/${profileId}`);
    }
  };

  const handleAddProfile = () => {
    history.push(`${routesConfig.TEAM_PAGE}/new`);
  };

  if (isDesktopView) {
    return (
      <ErrorBoundary>
        <PageLayout.PageWithSubNav>
          <PageLayout.ColumnSubNav>
            <TeamPage
              profiles={profiles}
              onProfileClick={handleProfileClick}
              isDesktopView={isDesktopView}
              selectedProfileId={id || null}
              onAddProfileClick={handleAddProfile}
            />
          </PageLayout.ColumnSubNav>
          {id && (
            <PageLayout.ContentContainer>
              <EmployeeProfileContent
                profileId={id}
                isDesktopView={isDesktopView}
              />
            </PageLayout.ContentContainer>
          )}
        </PageLayout.PageWithSubNav>
      </ErrorBoundary>
    );
  }

  // Mobile view - use the content component directly
  return (
    <ErrorBoundary>
      <PageLayout.Page>
        <PageLayout.ContentContainer>
          {id && (
            <EmployeeProfileContent
              profileId={id}
              isDesktopView={isDesktopView}
            />
          )}
        </PageLayout.ContentContainer>
      </PageLayout.Page>
    </ErrorBoundary>
  );
}
